import React from "react";
import { connect } from "react-redux";
import { useDesktopMediaQuery } from "Shared/Responsive";
import PoweredByImage from "src/images/powered-by.inline.svg";
import { ApplicationStore } from "src/store";
import "./SidebarLogos.scss";

const SidebarLogos = ({ logoHeader, name }: ReturnType<typeof mapStateToProps>) => {
    const isDesktop = useDesktopMediaQuery();

    if (!isDesktop) {
        return null;
    }

    return (
        <div className="SidebarLogos">
            <img className="SidebarLogos__logo" src={logoHeader} alt={name} />

            <div className="SidebarLogos__separator" />

            <PoweredByImage className="SidebarLogos__logo" />
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore) => ({
    logoHeader: state.account?.logo_splash ?? "",
    name: state.account.name,
});

export default connect(mapStateToProps)(SidebarLogos);
